import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);
const vuexLocalStorage = new VuexPersist({
  key: "vuex",
  storage: window.localStorage
});

export default new Vuex.Store({
  strict: true,
  state: {
    token: localStorage.getItem("token") || "",
    user: {
      prefered_currency: "USD"
    },
    isLoggedIn: false,
    maintenance_mode: false,
    videoUrl: process.env.VUE_APP_VIDEO_URL,
    baseUrl: process.env.VUE_APP_IMAGE_URL,
    serverUrl: process.env.VUE_APP_API_URL,
    searchQuery: {},
    reserveQuery: {}
  },
  plugins: [vuexLocalStorage.plugin],
  mutations: {
    setToken(state, token) {
      state.token = token;
      if (token) {
        state.isLoggedIn = true;
      } else {
        state.isLoggedIn = false;
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setSiteMode(state, maintenance_mode) {
      state.maintenance_mode = maintenance_mode;
    },
    setRole(state, role) {
      state.user.role = role;
    },
    setProfilePic(state, image) {
      state.user.profilePic = image;
    },
    logout(state) {
      state.token = "";
      state.user = {
        prefered_currency: "USD"
      };
      state.isLoggedIn = false;
    },
    setSearchQuery(state, query) {
      state.searchQuery = query;
    },
    setReserveQuery(state, query) {
      state.reserveQuery = query;
    }
  },
  actions: {
    setToken({ commit }, token) {
      commit("setToken", token);
    },
    setUser({ commit }, user) {
      commit("setUser", user);
    },
    setSiteMode({ commit }, maintenance_mode) {
      commit("setSiteMode", maintenance_mode);
    },
    setRole({ commit }, role) {
      commit("setRole", role);
    },
    setProfilePic({ commit }, image) {
      commit("setProfilePic", image);
    },
    logout({ commit }) {
      commit("logout");
      localStorage.removeItem("token");
    },
    setSearchQuery({ commit }, query) {
      commit("setSearchQuery", query);
    },
    setReserveQuery({ commit }, query) {
      commit("setReserveQuery", query);
    }
  },
  modules: {},
  getters: {
    isLoggedIn: state => !!state.token
  }
});
